import qs from 'qs';
import axios from 'axios';
import { http_get, http_put } from './helpers';
import { version } from './config';

export async function login(opt: { username: string; password: string }) {
    const res: unknown = await axios.post('/id/connect/token', qs.stringify({
        username: opt.username,
        password: opt.password,
        client_id: 'ibuilding3d',
        client_secret: 'secret',
        scope: 'iBuilding3D',
        grant_type: 'password',
    }));
    return res as {
        access_token: string;
        expires_in: number;
        token_type: 'Bearer';
        scope: 'iBuilding3D';
    } | {
        error: string;
        error_description: string;
        error_type: number;
    };
}

export const register = http_put<
    {
        phoneNumber: string;
        captcha: string;
        password: string;
    },
    void
>(`/api/v${version}/f/Account/Register`);

export const sendSMSCaptcha = http_get<
    {
        phoneNumber: string;
    },
    void
>(`/api/v${version}/f/Account/SMSCaptcha`);
